import './MainPage.css';
import React from 'react';
import { Outlet, Link as RouterLink } from 'react-router-dom';
import { IconButton, Link } from '@mui/material';
import Paper from '@mui/material/Paper';
import FacebookIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { trackNavigation, trackSocialMedia } from '../common/utils/analytics';

// Bluesky SVG Icon Component (official logo)
const BlueskyIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
    >
        <g fill="none">
            <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/>
            <path fill="currentColor" d="M5.892 2.93c-1.78-1.06-3.813.446-3.63 2.359l.398 4.185c.176 1.855 1.84 4.026 4.195 3.823C4.5 14 3.132 15.865 4.88 18.145c.286.373.597.745.914 1.062s.69.628 1.062.914c1.88 1.441 4.375-.65 5.055-2.69l.09-.268l.09.269c.68 2.04 3.174 4.13 5.055 2.689c.372-.286.745-.597 1.062-.914s.628-.69.914-1.062c1.747-2.28.379-4.145-1.976-4.848c2.355.203 4.018-1.968 4.195-3.823l.399-4.185c.182-1.913-1.852-3.418-3.631-2.36C15.2 4.66 13.485 7.393 12 9.902C10.515 7.392 8.8 4.66 5.892 2.93"/>
        </g>
    </svg>
);

const pages = [
    { name: 'Home', url: '/' },
    { name: 'Galleries', url: '/galleries' },
    // { name: 'About', url: '/about' },
    { name: 'Contact me', url: '/contacts' },
];

function MainPage() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = (e, page) => {
        setAnchorElNav(null);
        if (page) {
            trackNavigation(page.name);
        }
    };

    const handleNavClick = (pageName) => {
        trackNavigation(pageName);
    };

    const handleSocialClick = (platform) => {
        trackSocialMedia(platform);
    };

    return (
        <Paper className='main-page'>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Typography
                            variant="h4"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'ValeterFont',
                                fontWeight: 500,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            ValeTer
                        </Typography>

                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page.name} onClick={(e) => handleCloseNavMenu(e, page)}>
                                        <Link component={RouterLink} to={page.url} underline="none" color="inherit">
                                            <Typography textAlign="center">{page.name}</Typography>
                                        </Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                        <Typography
                            variant="h4"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'flex', md: 'none' },
                                flexGrow: 1,
                                fontFamily: 'ValeterFont',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            ValeTer
                        </Typography>
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (
                                <Button
                                    key={page.name}
                                    component={RouterLink}
                                    to={page.url}
                                    onClick={() => handleNavClick(page.name)}
                                    sx={{ my: 2, color: 'white', display: 'block', fontSize: '18px'}}
                                >
                                    {page.name}
                                </Button>
                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>
                            <IconButton 
                                href='http://facebook.com/ValeTerPhotography' 
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => handleSocialClick('Facebook')}
                                sx={{ p: 0, m: 1 }}
                            >
                                <FacebookIcon alt="Facebook" />
                            </IconButton>
                            <IconButton 
                                href='http://instagram.com/ValeTer_' 
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => handleSocialClick('Instagram')}
                                sx={{ p: 0, m: 1 }}
                            >
                                <InstagramIcon alt="Instagram" />
                            </IconButton>
                            <IconButton 
                                href='https://bsky.app/profile/valeter.bsky.social' 
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => handleSocialClick('Bluesky')}
                                sx={{ p: 0, m: 1 }}
                            >
                                <BlueskyIcon />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            <div className='page-content'>
                <Outlet />
            </div>
        </Paper>
    );
}

export default MainPage;
